import { useEffect, useState } from "react";
import { ColumnItem } from "../../common/models/table";
import { ActionsKey } from "../../common/models/Actions";
import { StorageService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { useStorageListState, useStorageStore } from "./store/StorageStore";
import { Loader } from "../../common/components/Loader/Loader";
import { Radio, Tag, Tooltip } from "antd";
import { LFTableV3 } from "../../common/components/LFTable/LFTableV3";
import { StoreStorageService } from "../settings/store_storage/core/_request";
import { OpenStorageService } from "../settings/open_storage/core/_request";
import { useNavigate, useSearchParams } from "react-router";
import { initialStoragePageState } from "./core/_model.storage";
import { FaHistory } from "react-icons/fa";
import { CustomDrawer } from "../../common/components/Drawer/CustomDrawer";
import { StorageHistoryDetail } from "./StorageHistoryDetail";
import { Assets } from "../../assets";
import { ImUpload } from "react-icons/im";
import { API_BASE_URL } from "../../utilities/API_CONSTANT";
import CustomModal from "../../common/components/Modal/CustomModal";
import { UploadTerrePlein } from "./components/forms/UploadTerrePlein";

enum StorageType {
  MAGASIN = "Magasin",
  TERRE_PLEIN = "Terres pleins",
}

const StorageList = () => {
  const { setStorageList, storageList, actioned, totalItems, setActioned } =
    useStorageStore();
  const { pageState, setPageState, resetPageState } = useStorageListState();

  const [isShowDrawer, setIsShowDrawer] = useState<boolean>(false);
  const [isShowImportForm, setIsShowImportForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedType, setSelectedType] = useState<"Magasin" | "Terres pleins">(
    "Magasin"
  );

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const typeParam = searchParams.get("storage_type");
    if (typeParam === "terres_pleins") {
      setSelectedType("Terres pleins");
    } else {
      setSelectedType("Magasin");
    }
    setIsInitialized(true); // set initial value is ready
  }, []);

  useEffect(() => {
    if (!isInitialized) return; // fetch when inital value is ready
    fetchAllStorage(pageState);
    const typeParam = selectedType === "Magasin" ? "magasin" : "terres_pleins";
    setSearchParams({ storage_type: typeParam });
  }, [pageState, selectedType, isInitialized]);

  const cols: ColumnItem[] = [
    {
      key: "name",
      title: "Entrepôt",
      dataIndex: "name",
      show: true,
      isCanSort: true,
      searchType: "text",
    },
    {
      key: "percent",
      title: "Etat",
      dataIndex: "percent",
      render: (value: any) => {
        if (value < 50) return <Tag color="green">{value} %</Tag>;
        return <Tag color="magenta">{value}</Tag>;
      },
      show: true,
      isCanSort: true,
    },
    {
      key: "capacity",
      title: selectedType === "Magasin" ? "Capacité (T)" : "Capacité",
      dataIndex: "capacity",
      render: (value: any) => <span>{value}</span>,
      show: true,
      isCanSort: true,
    },
    {
      key: "stock",
      title: selectedType === "Magasin" ? "En stockage (T)" : "En stockage",
      dataIndex: "stock",
      render: (value: any) => <span>{value}</span>,
      show: true,
      isCanSort: true,
    },
  ];

  const handleShowImport = () => {
    setIsShowImportForm((prev: boolean) => !prev);
  };

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "read") {
      onEditStorage(item.id);
    } else {
      getOne(item?.id, action);
    }
  };

  const onEditStorage = (id: number) => {
    //navigate(`/app/storage/detail/${id}`);
    navigate(
      `/app/storage/detail/${id}?storage_type=${
        selectedType === StorageType.MAGASIN ? "magasin" : "terres_pleins"
      }`
    );
  };

  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await StorageService.getStorageById(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: { ...res?.data },
          action,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllStorage = async (params?: any) => {
    try {
      setIsLoading(true);
      let res;
      if (selectedType === "Magasin") {
        res = await StoreStorageService.getStoreStorageList(params);
      } else {
        res = await OpenStorageService.getOpenStorageList(params);
      }
      if (res?.status === HttpStatusCode.Ok) {
        setStorageList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  const onShowDrawerHandler = () => {
    setIsShowDrawer((prev: boolean) => !prev);
  };

  const onClickHistoryDetail = (row: any) => {
    setActioned({
      action: "read",
      data: row,
    });
    onShowDrawerHandler();
  };

  const onRefresh = () => {
    fetchAllStorage(pageState);
  };
  return (
    <div className="">
      <Loader isLoading={isLoading} />

      <div className="mt-2 d-flex w-100 justify-content-between">
        <Radio.Group
          options={[StorageType.MAGASIN, StorageType.TERRE_PLEIN]}
          onChange={(e) => {
            setSelectedType(e.target.value);
            setPageState(initialStoragePageState);
          }}
          value={selectedType}
          optionType="button"
          buttonStyle="solid"
        />
        {selectedType === StorageType.TERRE_PLEIN ? (
          <div className="">
            <div
              className="mb-2 d-flex justify-content-center cursor-pointer gap-3 card_button"
              style={{
                backgroundColor: "#ffffff",
              }}
              onClick={handleShowImport}
            >
              <ImUpload
                      style={{
                        fontSize: "26px",
                        color: "green",
                        cursor: "pointer",
                      }}
                    />
              <span
                style={{
                  fontWeight: "bolder",
                  color: "GrayText",
                }}
              >
                {" "}
                Bon d'entrée manuel{" "}
              </span>
            </div>{/* 
            <div className="d-flex gap-4">
              <div className="card_button">
                <Tooltip title="Import">
                  <div className="" onClick={handleShowImport}>
                    <ImUpload
                      style={{
                        fontSize: "26px",
                        color: "green",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </Tooltip>
              </div>
              <div className="card_button">
                <Tooltip title="Export modèle">
                  <a
                    href={`${API_BASE_URL}/templates/bon_entree.xlsx`}
                    download
                    className=""
                    target="_blank"
                    // className={style.basic__link}
                  >
                    <img
                      alt="export_excel"
                      src={Assets.icons.png.excel}
                      style={{
                        // fontSize: "22px",
                        height: "26px",
                        width: "26px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        console.log("aaaaaaa");
                      }}
                    />
                  </a>
                </Tooltip>
              </div>
            </div> */}
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="mt-4">
        <LFTableV3
          columns={cols}
          data={storageList}
          params={pageState}
          onAction={onActionClick}
          isCanShow={() => true}
          onSearch={handleSetParams}
          onSort={handleSetParams}
          onResetSearch={resetPageState}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          otherActions={[
            ({ row }) => (
              <Tooltip title={"Historiques"}>
                <div
                  className=" cursor-pointer"
                  onClick={() => {
                    onClickHistoryDetail(row);
                  }}
                >
                  <FaHistory />
                </div>
              </Tooltip>
            ),
          ]}
          onChangePage={handleSetParams}
        />
      </div>
      {isShowImportForm ? (
        <CustomModal
          title={
            <div>
              <p>
                Import bon d'entrée
                <span
                  style={{
                    color: " #ff4d4f",
                  }}
                >
                  *
                </span>
              </p>
            </div>
          }
          isOpen={isShowImportForm}
          hanldeCloseModal={handleShowImport}
        >
          <UploadTerrePlein
            onFinish={() => {
              onRefresh();
              handleShowImport();
            }}
          />
        </CustomModal>
      ) : (
        ""
      )}

      {isShowDrawer ? (
        <CustomDrawer
          isOpen={isShowDrawer}
          onClose={onShowDrawerHandler}
          title={"Historiques"}
          width={"75%"}
        >
          <StorageHistoryDetail initialState={actioned?.data} />
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};

export default StorageList;
